import React from 'react';

import { childOfferListArray } from 'config/Filter/sectionCollection';

import { useOccupancy } from 'hooks/form/search';
import { QaIdentifier } from 'hooks/useQa';

import ScopedAttribute from '../ScopedAttribute';
import { MetaValue } from '../Segment/__hooks/useDisabledStatus';

const ChildrenOffer = ({ disableWhen = MetaValue.NoResult }) => {
    const [occupancy] = useOccupancy();
    const hasChild = occupancy.childCount > 0;
    if (!hasChild) {
        return null;
    }

    return (
        <ScopedAttribute
            attributeListArray={childOfferListArray}
            headlineKey="TRANS-offers-for-children"
            disableWhen={disableWhen}
            qaIdentifier={QaIdentifier.Search_Filter_Section_ChildrenOffer}
        />
    );
};

export default ChildrenOffer;
